import styled from 'styled-components';
import { Molecule } from 'AppReact';
import { SearchInput } from './atoms'

const template = styled.div`
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
`

export default Molecule({
  type: 'formgroup',
  template,
  atoms: [
    {
      component: SearchInput,
      name: 'SearchInput',
      displayState: ({ hideBorder }) => ({ hideBorder })
    }
  ]
})